import React, { useMemo } from 'react';

export default function CuponesToolbar({ value, onChange, onSearch, onClear, disabled }) {
    const v = value || {};

    const onKeyDown = (e) => {
        if (e.key === 'Enter') onSearch?.();
    };

    const activeLabel = useMemo(() => {
        if (String(v.activo) === '1') return 'Activos';
        if (String(v.activo) === '0') return 'Inactivos';
        return 'Todos';
    }, [v.activo]);

    return (
        <div className="cupon-toolbar">
            <div className="cupon-toolbar__row">
                <div className="cupon-field">
                    <div className="cupon-label">Buscar</div>
                    <div className="cupon-input-wrap">
                        <span className="cupon-input-ico" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" fill="none" stroke="currentColor" strokeWidth="2.2" />
                                <path d="M16.5 16.5 21 21" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                            </svg>
                        </span>
                        <input
                            className="cupon-input"
                            placeholder="Código, título..."
                            value={v.q || ''}
                            onChange={(e) => onChange?.((p) => ({ ...p, q: e.target.value }))}
                            onKeyDown={onKeyDown}
                            disabled={!!disabled}
                        />
                    </div>
                </div>

                <div className="cupon-field">
                    <div className="cupon-label">Estado</div>
                    <select
                        className="cupon-select"
                        value={v.activo ?? 'all'}
                        onChange={(e) => onChange?.((p) => ({ ...p, activo: e.target.value }))}
                        disabled={!!disabled}
                    >
                        <option value="all">Todos</option>
                        <option value="1">Activos</option>
                        <option value="0">Inactivos</option>
                    </select>
                </div>

                <div className="cupon-field">
                    <div className="cupon-label">Tipo</div>
                    <select
                        className="cupon-select"
                        value={v.tipo_descuento ?? 'all'}
                        onChange={(e) => onChange?.((p) => ({ ...p, tipo_descuento: e.target.value }))}
                        disabled={!!disabled}
                    >
                        <option value="all">Todos</option>
                        <option value="percent">% Porcentaje</option>
                        <option value="fixed">$ Monto fijo</option>
                    </select>
                </div>

                <div className="cupon-toolbar__actions">
                    <button className="cupon-btn cupon-btn--primary" type="button" onClick={onSearch} disabled={!!disabled}>
                        <span className="cupon-btn__icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24"><path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" fill="none" stroke="currentColor" strokeWidth="2.2" /><path d="M16.5 16.5 21 21" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" /></svg>
                        </span>
                        Buscar
                    </button>

                    <button className="cupon-btn cupon-btn--ghost" type="button" onClick={onClear} disabled={!!disabled}>
                        <span className="cupon-btn__icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>
                        </span>
                        Limpiar
                    </button>
                </div>
            </div>
        </div>
    );
}
